// src/pages/ems/EmsHome.js
import React from 'react';
import '../css/EmsHome.css';

const EmsHome = () => {
  return (
    <div className="ems-outlet-content">
      <div className="ems-content-area">
        <h1>Welcome to the IGF Event Management System</h1>
        <p className="ems-location-info">Event Management Platform - Los Angeles, California - July 21 - August 6, 2028</p>

        <div className="ems-card-and-button">
          <div className="event-management-card">
            <h2 className="card-title">Event Management Dashboard</h2>
            <hr className="card-separator" />
            <p className="card-description">
              Manage events, registration forms, and participant bookings for the Olympic Games 2028.
              <br /> Access all tools needed to efficiently coordinate dashboard for athletes, officials, and staff.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmsHome;